import React from 'react';
export function ProblemSection() {
  return <section className="w-full bg-[#0A0A0F] py-8 px-4 pt-[0px] pb-[0px]" data-id="element-164">
      <div className="max-w-3xl mx-auto text-center" data-id="element-165">
        <h2 className="text-xl sm:text-2xl font-bold text-white mb-6" data-id="element-166">
          Si eres entrenador de vóley,
          <br data-id="element-167" />
          <span className="text-[#FF6B00]" data-id="element-168">esto te va a sonar familiar:</span>
        </h2>

        <div className="space-y-2 text-left mb-8" data-id="element-169">
          <div className="flex items-start gap-3 bg-[#16161F] border border-[#FF6B0033] rounded-xl p-3" data-id="element-170">
            <span className="text-[#FF6B00] text-lg flex-shrink-0" data-id="element-171">❌</span>
            <p className="text-white text-sm font-medium" data-id="element-172">
              Llegas a la cancha sin saber exactamente qué ejercicio vas a dar
            </p>
          </div>
          <div className="flex items-start gap-3 bg-[#16161F] border border-[#FF6B0033] rounded-xl p-3" data-id="element-173">
            <span className="text-[#FF6B00] text-lg flex-shrink-0" data-id="element-174">❌</span>
            <p className="text-white text-sm font-medium" data-id="element-175">
              Tus jugadores no progresan porque no hay una secuencia clara
            </p>
          </div>
          <div className="flex items-start gap-3 bg-[#16161F] border border-[#FF6B0033] rounded-xl p-3" data-id="element-176">
            <span className="text-[#FF6B00] text-lg flex-shrink-0" data-id="element-177">❌</span>
            <p className="text-white text-sm font-medium" data-id="element-178">
              El 60% abandona antes del año y no sabes cómo frenarlo
            </p>
          </div>
          <div className="flex items-start gap-3 bg-[#16161F] border border-[#FF6B0033] rounded-xl p-3" data-id="element-179">
            <span className="text-[#FF6B00] text-lg flex-shrink-0" data-id="element-180">❌</span>
            <p className="text-white text-sm font-medium" data-id="element-181">
              Cuando hay partido o feriado pierdes la continuidad
            </p>
          </div>
          <div className="flex items-start gap-3 bg-[#16161F] border border-[#FF6B0033] rounded-xl p-3" data-id="element-182">
            <span className="text-[#FF6B00] text-lg flex-shrink-0" data-id="element-183">❌</span>
            <p className="text-white text-sm font-medium" data-id="element-184">
              No puedes justificar un aumento de precio ante los padres
            </p>
          </div>
          <div className="flex items-start gap-3 bg-[#16161F] border border-[#FF6B0033] rounded-xl p-3" data-id="element-185">
            <span className="text-[#FF6B00] text-lg flex-shrink-0" data-id="element-186">❌</span>
            <p className="text-white text-sm font-medium" data-id="element-187">
              Jugadores de distintos niveles juntos igual a caos
            </p>
          </div>
          <div className="flex items-start gap-3 bg-[#16161F] border border-[#FF6B0033] rounded-xl p-3" data-id="element-188">
            <span className="text-[#FF6B00] text-lg flex-shrink-0" data-id="element-189">❌</span>
            <p className="text-white text-sm font-medium" data-id="element-190">
              Sin sistema de evaluación formal nadie ve el progreso
            </p>
          </div>
        </div>

        <p className="text-[#FF6B00] text-2xl sm:text-3xl font-black mb-6" data-id="element-191">
          ¿Cuántas sesiones más vas a improvisar?
        </p>

        {/* Orange divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-[#FF6B00] to-transparent w-full" data-id="element-192" />
      </div>
    </section>;
}